import { ActvityEventFilters } from "@safetyculture/s12-apis-connect-web/s12/accounts/history/v1/history_pb";
import {
  ListUsersActivityLogEventsRequest,
  ListUsersActivityLogEventsResponse,
} from "@safetyculture/s12-apis-connect-web/s12/accounts/history/v1/history_pb";
import { SudoHistoryFilters } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/sudo_filters_pb";
import { AuditLogsFilters } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_audit_logs_pb";
import {
  ListAuditLogsRequest,
  ListAuditLogsResponse,
  ListOrganisationActivityRequest,
  ListOrganisationActivityResponse,
  ListSudoHistoryRequest,
  ListSudoHistoryResponse,
  Pagination,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

import { supportServiceConnectClient } from "../index";
import { RequestMetadata } from "api/types";

type ListAuditLogsParams = {
  pageSize: number;
  pageToken?: string;
  filters?: AuditLogsFilters;
};

export const listAuditLogs = async (
  { pageSize, pageToken, filters }: ListAuditLogsParams,
  headers: Record<RequestMetadata, string>,
): Promise<ListAuditLogsResponse> => {
  const req = new ListAuditLogsRequest({
    pageSize,
  });

  if (pageToken) {
    req.pageToken = pageToken;
  }

  if (filters !== undefined) {
    req.filters = filters;
  }

  return supportServiceConnectClient.listAuditLogs(req, { headers });
};

type ListSudoHistoryParams = {
  pageSize: number;
  offset: number;
  filters?: SudoHistoryFilters;
};

export const listSudoHistory = async (
  { pageSize, offset, filters }: ListSudoHistoryParams,
  headers: Record<RequestMetadata, string>,
): Promise<ListSudoHistoryResponse> => {
  const pagination = new Pagination({
    pageSize,
    offset,
  });

  const req = new ListSudoHistoryRequest({
    pagination,
  });

  if (filters !== null) {
    req.filters = filters;
  }

  return supportServiceConnectClient.listSudoHistory(req, { headers });
};

type ListOrganisationActivityParams = {
  orgId: string;
  pageSize: number;
  pageToken?: string;
  filters?: ActvityEventFilters;
};

export const listOrganisationActivity = async (
  { orgId, pageSize, pageToken, filters }: ListOrganisationActivityParams,
  headers: Record<RequestMetadata, string>,
): Promise<ListOrganisationActivityResponse> => {
  const req = new ListOrganisationActivityRequest({
    orgId,
    pageSize,
  });

  if (pageToken) {
    req.pageToken = pageToken;
  }

  if (filters) {
    req.filters = filters;
  }

  return supportServiceConnectClient.listOrganisationActivity(req, { headers });
};

export type ListUserActivityParams = {
  userIds: string[];
  orgIds: string[];
  pageSize: number;
  pageToken?: string;
  filters?: ActvityEventFilters;
};

export const listUserActivity = async (
  { userIds, orgIds, pageSize, pageToken, filters }: ListUserActivityParams,
  headers: Record<RequestMetadata, string>,
): Promise<ListUsersActivityLogEventsResponse> => {
  const req = new ListUsersActivityLogEventsRequest({
    userIds,
    orgIds,
    pageSize,
  });

  if (pageToken) {
    req.pageToken = pageToken;
  }

  if (filters) {
    req.filters = filters;
  }

  return supportServiceConnectClient.listUsersActivityLogEvents(req, {
    headers,
  });
};
